import DepartmentsSelector from './DepartmentsSelector';
export default DepartmentsSelector;
